var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-card"},[_c('img',{staticClass:"error-card__image",attrs:{"src":require("@/assets/icons/card-form/error.svg")}}),_c('p',{staticClass:"error-card__text"},[_vm._v(" "+_vm._s(_vm.$te('error-reasons.' + _vm.errorText) ? _vm.$t('error-reasons.' + _vm.errorText) : _vm.errorText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }